import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryIdeaUserInterviewAttributes } from './generated/DiscoveryIdeaUserInterviewAttributes';
import { model } from '../modelBuilder';

interface DiscoveryIdeaUserInterview
  extends DiscoveryIdeaUserInterviewAttributes {}

@model
class DiscoveryIdeaUserInterview extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryIdeaUserInterview' = 'DiscoveryIdeaUserInterview';
  get typename(): 'DiscoveryIdeaUserInterview' {
    return 'DiscoveryIdeaUserInterview';
  }

  static internalTypename: 'Discovery::IdeaUserInterview' =
    'Discovery::IdeaUserInterview';
  get internalTypename(): 'Discovery::IdeaUserInterview' {
    return 'Discovery::IdeaUserInterview';
  }

  static inputType = 'InterviewAttributes!';

  static fields = {
    aiSummary: attr({ writable: true, readable: false }),
    anonymized: attr({ writable: true, readable: false }),
    disableUploadSteps: attr({ writable: true, readable: false }),
    discoveryInterviewTypeId: attr({ writable: true, readable: false }),
    endTime: attr({ writable: true, readable: false }),
    id: attr({ readable: true }),
    ideaUserId: attr({ readable: true }),
    meetingName: attr({ readable: true }),
    mode: attr({ writable: true, readable: false }),
    name: attr({ writable: true, readable: false }),
    sentiments: attr({ writable: true, readable: false, json: true }),
    startTime: attr({ writable: true, readable: false }),
    status: attr({ writable: true, readable: false }),
    ideaUser: attr.belongsTo({ readable: true, typename: 'IdeaUser' }),
  };
  // End auto-generated
}

export default DiscoveryIdeaUserInterview;
